const ADVANTAGES = [
  { icon: 'ri-gift-line', title: '完全免费', desc: '全站资源免费浏览，无需注册即可获取信息。' },
  { icon: 'ri-folders-line', title: '分类清晰', desc: '视频、软件、教程三大频道，子分类与筛选齐备。' },
  { icon: 'ri-refresh-line', title: '持续更新', desc: '每日收录新资源，第一时间跟上内容节奏。' },
  { icon: 'ri-shield-check-line', title: '安全放心', desc: '资源来源清晰标注，拒绝捆绑与不明安装包。' },
];

const STATS = [
  { value: '200+', label: '免费资源' },
  { value: '15+', label: '细分分类' },
  { value: '100万+', label: '累计访问' },
  { value: '每日', label: '内容更新' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              关于免费91
            </span>
            <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950 leading-snug">
              一个专注于免费优质内容的资源平台
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              免费91 致力于把散落在网络各处的免费视频、软件与教程整理归类，让查找不再费劲。
              我们坚持真实标注来源与作者，鼓励学习交流，帮助你在有限的时间里更快获得有价值的内容。
            </p>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              无论你是学生、职场人还是兴趣爱好者，都能在这里找到适合自己的资源频道。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {STATS.map((stat) => (
                <div key={stat.label} className="rounded-lg bg-background-50 border border-background-200 px-3 py-4 text-center">
                  <p className="font-heading font-bold text-xl md:text-2xl text-primary-700">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {ADVANTAGES.map((item) => (
              <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}